import React from 'react';

class GenericPanel extends React.Component { 
  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          <span className="panel-title">{this.props.title}</span>
        </div>
        <span className="panel-body">
          {this.props.children}
        </span>
      </div>
    )
  }
}

export default GenericPanel;